import { i18next } from '@yola/ws-sdk';
import optionTypes from '../../../constants/option-types';
import generateModifiedEventTraits from '../../../helpers/generate-modified-event-traits';
import computeContentAlignmentFallback from '../helpers/compute-content-alignment-fallback';

const ALIGNMENTS = {
  left: {
    id: 'left',
    glyph: 'align-left',
    value: 'left',
  },
  center: {
    id: 'center',
    glyph: 'align-center',
    value: 'center',
  },
  right: {
    id: 'right',
    glyph: 'align-right',
    value: 'right',
  },
};

const getChoices = () => [
  {
    ...ALIGNMENTS.left,
    label: i18next.t('Left'),
  },
  {
    ...ALIGNMENTS.center,
    label: i18next.t('Center'),
  },
  {
    ...ALIGNMENTS.right,
    label: i18next.t('Right'),
  },
];

const getAlignmentByValue = (val) => Object.values(ALIGNMENTS).find(({ value }) => value === val);
const getModifiedEventTraits = ({ eventTraitPrefix, optionId, newValue, oldValue }) => {
  const relatedNewValueId = getAlignmentByValue(newValue).id;
  const relatedOldValueId = getAlignmentByValue(oldValue)?.id;

  return generateModifiedEventTraits(
    eventTraitPrefix,
    optionId,
    relatedOldValueId,
    relatedNewValueId
  );
};

const getHorizontalContentAlignment = (settings = {}) => ({
  ...settings,
  id: 'horizontal-content-alignment',
  type: optionTypes.ACTION_RADIO_GROUP,
  title: i18next.t('Horizontal'),
  attributes: ['alignment'],
  computeFallbackValue: computeContentAlignmentFallback,
  getModifiedEventTraits,
  choices: getChoices(),
});

export default getHorizontalContentAlignment;
